@if (this.loader.getLoading()) {
  <div class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
  </div>
}